/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import InputField from "../../../@common/InputField";
import Dropdown from "../../../@common/Dropdown";
import AutocompleteSelect from "../../../@common/AutocompleteSelect";
import { replaceObjectWithValueId } from "../../../../utils/common";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import AutocompleteMultiSelect from "../../../@common/AutoCompleteMultiSelect";

interface IUseDynamicFilters {
  onApplyFilters: (() => void) | undefined;
  filterValues: any;
  filterStructure: any[];
}
const useDynamicFilters = ({
  onApplyFilters,
  filterValues,
  filterStructure,
}: IUseDynamicFilters) => {
  const ref = useRef<any>({});
  useEffect(() => {
    let newValues = filterStructure.reduce((acc, item) => {
      if (
        item.type !== "inputField" &&
        typeof filterValues?.[item.key] !== "undefined" &&
        filterValues?.[item.key] !== null
      ) {
        acc[item.key] = filterValues?.[item.key];
      }
      return acc;
    }, {});
    if (JSON.stringify(newValues) !== JSON.stringify(ref.current)) {
      applyFilter();
    }
    ref.current = newValues;
  }, [filterValues]);

  const fieldTypes: any = {
    inputField: ({ data, handleChange, values = "" }: any) => {
      return (
        <>
          <InputField
            name={data.name}
            type={data?.inputType ? data?.inputType : "text"}
            inputProps={data?.inputProps ? data?.inputProps : {}}
            handleChange={(e: any) => handleChange(data.key, e?.target?.value)}
            values={values}
            label={data.label}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                applyFilter();
              }
            }}
          />
        </>
      );
    },
    dropdown: ({ data, handleChange, values }: any) => {
      return (
        <Dropdown
          name={data.name}
          handleChange={(e: any) => {
            handleChange(data.key, e?.target?.value);
          }}
          options={data.options}
          label={data.label}
          value={values}
          enableDefault={true}
        />
      );
    },
    autocompleteSingleSelect: ({ data, handleChange, values }: any) => {
      return (
        <AutocompleteSelect
          name={data.name}
          onSelect={(value: any) => {
            handleChange(data.key, replaceObjectWithValueId(value)?.id);
          }}
          selectedValues={values}
          func={data?.func}
          label={data.label}
        />
      );
    },
    autocompleteMultiSelect: ({ data, handleChange, values }: any) => {
      return (
        <AutocompleteMultiSelect
          name={data.name}
          onSelect={(value: any) => {
            handleChange(data.key, value);
          }}
          selectedValues={values}
          func={data?.func}
          label={data.label}
        />
      );
    },
    date: ({ data, handleChange, values }: any) => {
      return (
        <div>
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={values ? dayjs(values) : null}
          onChange={(value: any) => {
            if (!value) return;
            const date = new Date(value);
            const istDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
            const formattedValue = dayjs(istDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            handleChange(data.key, formattedValue);
          }}
          label={data?.label}
        />
      </LocalizationProvider> */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={values ? dayjs(values) : null}
              onChange={(value: any) => {
                if (!value) return;
                const date = new Date(value);
                const istDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                const formattedValue = dayjs(istDate).format('YYYY-MM-DD');
                handleChange(data.key, formattedValue);
              }}
              label={data?.label}
            />
          </LocalizationProvider>
        </div>
      );
    },

    nextLine: () => {
      return (
        <div>
          <br />
        </div>
      );
    },
    // You can define more field types and their components here
  };
  const applyFilter = () => {
    // onApplyFilters
    if (onApplyFilters) {
      setTimeout(() => {
        onApplyFilters();
      }, 300);
    }
  };
  return { fieldTypes };
};

export default useDynamicFilters;
